// mui
import { makeStyles } from '@material-ui/core/styles'

// custom hooks
import useServiceDetail from './useServiceDetail'

// third party libraries
import { useParams } from 'react-router-dom'
import { Reorder, useDragControls } from 'framer-motion'

// custom components
import DragIconButton from '../../../1elements/Buttons/IconButtons/DragIconButton'

const ServiceDetail = ({
  editMode, admin, data, index, resetToDefault, reorderFields, updateDataType,
  toggleIsHidden, updateFieldLabel, isCardDirty, toggleDeleteConfirmationModal
}) => {
  const { viewSwitcher } = useServiceDetail({ admin })
  const { cardId } = data
  const controls = useDragControls()
  const { tabName } = useParams()
  const classes = useStyles({ admin, tabName })

  return (
    <Reorder.Item key={cardId} value={data} className={classes.root} drag dragListener={false} dragControls={controls}>
      {admin && <DragIconButton controls={controls} className={classes.dragIconButton} />}
      {viewSwitcher(editMode, admin, data, reorderFields, index, updateFieldLabel, toggleDeleteConfirmationModal, resetToDefault, isCardDirty, toggleIsHidden, updateDataType)}
    </Reorder.Item>
  )
}

export default ServiceDetail

const useStyles = makeStyles((theme) => ({
  root: {
    gridColumn: 'span 8',
    gridRow: props => props.tabName === 'tab2' ? 'span 4' : 'span 3',
    padding: '25px 20px 0 50px',
    margin: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    position: 'relative',
    border: props => props.admin ? `1px dashed ${theme.palette.tertiary.main}` : 'none',
    backgroundColor: theme.palette.quaternary.main,
    maxHeight: props => props.tabName === 'tab2' ? 'calc((88vh - 220px) / 3)' : 'calc((88vh - 235px) / 4)',
    overflowY: 'auto'
  },
  dragIconButton: {
    position: 'absolute',
    right: 10,
    top: 20
  }
}))
